var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"tab"},[_c('div',{staticClass:"tabList"},[_c('div',{staticClass:"value"},[_c('ul',_vm._l((_vm.tabList),function(item,index){return _c('li',{key:index,class:_vm.tabIndex == index ? 'active' : '',on:{"click":function($event){return _vm.tabChange(index)}}},[_c('span',[_vm._v(_vm._s(item))])])}),0)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3ccf45c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabMenu.vue
// module id = null
// module chunks = 